<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmDistribution"
            :title="$lang.Reports.SLA.TitleForm"
            :showHelp="true"
            :showClearButton="true"
            :showSearchButton="true"
            :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
            v-on:Clear="onClear"
            v-on:Search="onSearch">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxInsure">  {{$lang.Sinister.Search.Insurer}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.insurance.value"
                      :options="form.insurance.options"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDate"> {{$lang.Sinister.Search.DateStart}}:</label>
          <div class="input-group">
            <datepicker name="txtSinisterDate"
                        v-model="form.sinisterDateStart.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDate"> {{$lang.Sinister.Search.DateEnd}}:</label>
          <div class="input-group">
            <datepicker name="txtSinisterDate"
                        v-model="form.sinisterDateEnd.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.Sinister.Search.Stage}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      v-model="form.stage.value"
                      :options="form.stage.options"/>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ReportSLA from './sla.js'

export default ReportSLA
</script>



// WEBPACK FOOTER //
// src/views/private/reports/sla/sla.vue